<template>
  <div class="item-view daily-report">
    <router-link to="/plan/feed" class="back-link">
      <Flexy><img :src="ArrowRightIcon" />
          <p>{{t('Measurement')}}</p>
      </Flexy>
      <small v-if="!readOnly">
        {{t('measurement-intro')}}
      </small>
    </router-link>
      <div>
        <div class="panel raw">
          <InputWrapper :label="t('chest-question')" :mandatory-sign="true" type="number" v-model="chest" :placeholder="t('circumference-placeholder')" />
          <InputWrapper :label="t('waist-question')" :mandatory-sign="true" type="number" v-model="waist" :placeholder="t('circumference-placeholder')" />
          <InputWrapper :label="t('hips-question')" :mandatory-sign="true" type="number" v-model="hips" :placeholder="t('circumference-placeholder')" />
        </div>
      </div>
      <div v-if="readOnly" class="read-only-report">
        <button class="btn btn-primary" @click="onSubmitMeasurement">{{t('Update Weighting')}}</button>
      </div>
      <p class="centered danger" v-if="fillWarning">{{t("Please fill in all the fields")}}</p>
      <div class="buttons">
        <button v-if="!readOnly" class="btn btn-primary" @click="onSubmitMeasurement">{{t('Send measurements')}}</button>
      </div>
  </div>
</template>

<script>
import t from '@/lib/Locale';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import Flexy from "@/components/ui/widgets/Flexy.vue";
import {getDailyQuiz} from "@/lib/DailyQuizUtils";
import Fito from "@/lib/fito";
import InputWrapper from "@/components/ui/widgets/InputWrapper.vue";

export default {
  name: "DailyReport",
  components: {InputWrapper, Flexy},
  data() {
    return {
      reportCompleted: false,
      readOnly: false,
      fillWarning: false,
      ArrowRightIcon,
      chest: '',
      waist: '',
      hips: '',
    }
  },
  mounted() {
    this.init()
  },
  computed : {
    day() {
      return this.$route.params.day || 1
    },
    isWeeklyReport() {
        const d = this.day * 1
        return d % 7 === 0 || d === 6
    },
    isFirstWeighting() {
      const d = this.day * 1
      return d === 1
    },
  },
  methods : {
    t,

    finalSliderValue(v) {
      console.log({v})
      v *= 1
      v += 3
      v /= 6
      v = parseFloat((1 - v)*100).toFixed(0)
      return v
    },

    planWeekday(planDay) {
        let weekday = planDay % 7
        if (weekday === 0) weekday = 7
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        return t(days[weekday - 1])
    },

    planWeek(planDay) {
        return Math.floor(planDay / 7) + 1
    },

    async onSubmitMeasurement() {
      this.fillWarning = false
      if (!this.chest || !this.hips || !this.waist) {
        this.fillWarning = true
        return
      }
      await Fito().RunAction('submit-waist', {day: this.day, chest: this.chest, waist: this.waist, hips: this.hips})
      await this.$router.push('/plan/feed?submitted_measurement')
    },

    async init() {
      const login = await Fito().Login.safeCheckLogin()
      if (!login) return this.$router.push('/plan/login')

      const day = this.$route.params.day || 1

      // if data exists, apply it
      let measurements = login.meta.waist_measure || [];
      measurements = measurements.filter(it => it.day*1 === day*1);
      let measurement = measurements[measurements.length - 1]
      if (measurement) {
        this.chest = measurement.chest;
        this.waist = measurement.waist;
        this.hips = measurement.hips;
        this.reportCompleted = true;
        this.readOnly = true;
      }


      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
  },
}
</script>
